import { AppRouteType, delayLazyLoad } from '../helper';
import routesMap from '../routesMap';
import { lazy, useMemo } from 'react';

const HomePage = lazy(() => delayLazyLoad(import('../../pages/HomePage')));
const CustomerStatisticPage = lazy(() => delayLazyLoad(import('../../pages/HomePage/day')));
const WeekStatisticPage = lazy(() => delayLazyLoad(import('../../pages/HomePage/week')));
const CustomerPage = lazy(() => delayLazyLoad(import('../../pages/Customer')));
const AddCustomerPage = lazy(() => delayLazyLoad(import('../../pages/Customer/add')));
const UpdateCustomerPage = lazy(() => delayLazyLoad(import('../../pages/Customer/update')));
const HistoryTreatment = lazy(() => delayLazyLoad(import('../../pages/Customer/HistoryTreatment')));
const AddTreatment = lazy(() => delayLazyLoad(import('../../pages/Customer/addtreatment')));
const MedicinePage = lazy(() => delayLazyLoad(import('../../pages/Medicine')));
const AddMedicinePage = lazy(() => delayLazyLoad(import('../../pages/Medicine/add')));
const UpdateMedicinePage = lazy(() => delayLazyLoad(import('../../pages/Medicine/update')));
const ImportMedicinePage = lazy(() => delayLazyLoad(import('../../pages/Medicine/import')));
const AddImportMedicinePage = lazy(() => delayLazyLoad(import('../../pages/Medicine/addImport')));
const EditImportMedicinePage = lazy(() => delayLazyLoad(import('../../pages/Medicine/editImport')));
const BatchImportMedicinePage = lazy(() => delayLazyLoad(import('../../pages/Medicine/importBatch')));
const EditTreatmentPage = lazy(() => delayLazyLoad(import('../../pages/Customer/editTreatment')));
const ProcessPage = lazy(() => delayLazyLoad(import('../../pages/Process')));
const ProcessTreatment = lazy(() => delayLazyLoad(import('../../pages/Process/process')));
const ActivityLogPage = lazy(() => delayLazyLoad(import('../../pages/ActivityLog')));
const SearchPage = lazy(() => delayLazyLoad(import('../../pages/Search')));
const RecallPage = lazy(() => delayLazyLoad(import('../../pages/Recall')));
const DebtPage = lazy(() => delayLazyLoad(import('../../pages/Debt')));

const routes: AppRouteType[] = [
  {
    path: routesMap.HOME,
    component: HomePage,
    rule: -1,
    openKey: [],
    activeKey: [routesMap.HOME],
  },
  {
    path: routesMap.CUSTOMER_STATISTIC,
    component: CustomerStatisticPage,
    rule: -1,
    openKey: [],
    activeKey: [routesMap.HOME],
  },
  {
    path: routesMap.WEEK_STATISTIC,
    component: WeekStatisticPage,
    rule: -1,
    openKey: [],
    activeKey: [routesMap.HOME],
  },
  {
    path: routesMap.CUSTOMER,
    component: CustomerPage,
    rule: -1,
    openKey: [],
    activeKey: [routesMap.CUSTOMER],
  },
  {
    path: routesMap.ADD_CUSTOMER,
    component: AddCustomerPage,
    rule: -1,
    openKey: [],
    activeKey: [routesMap.CUSTOMER],
  },
  {
    path: routesMap.UPDATE_CUSTOMER,
    component: UpdateCustomerPage,
    rule: -1,
    openKey: [],
    activeKey: [routesMap.CUSTOMER],
  },
  {
    path: routesMap.TREATMENT,
    component: HistoryTreatment,
    rule: -1,
    openKey: [],
    activeKey: [routesMap.CUSTOMER],
  },
  {
    path: routesMap.ADD_TREATMENT,
    component: AddTreatment,
    rule: -1,
    openKey: [],
    activeKey: [routesMap.CUSTOMER],
  },
  {
    path: routesMap.MEDICINE,
    component: MedicinePage,
    rule: -1,
    openKey: [],
    activeKey: [routesMap.MEDICINE],
  },
  {
    path: routesMap.ADD_MEDICINE,
    component: AddMedicinePage,
    rule: -1,
    openKey: [],
    activeKey: [routesMap.MEDICINE],
  },
  {
    path: routesMap.UPDATE_MEDICINE,
    component: UpdateMedicinePage,
    rule: -1,
    openKey: [],
    activeKey: [routesMap.MEDICINE],
  },
  {
    path: routesMap.IMPORT_MEDICINE,
    component: ImportMedicinePage,
    rule: -1,
    openKey: [],
    activeKey: [routesMap.MEDICINE],
  },
  {
    path: routesMap.ADD_IMPORT_MEDICINE,
    component: AddImportMedicinePage,
    rule: -1,
    openKey: [],
    activeKey: [routesMap.MEDICINE],
  },
  {
    path: routesMap.EDIT_IMPORT_MEDICINE,
    component: EditImportMedicinePage,
    rule: -1,
    openKey: [],
    activeKey: [routesMap.MEDICINE],
  },
  {
    path: routesMap.BATCH_IMPORT_MEDICINE,
    component: BatchImportMedicinePage,
    rule: -1,
    openKey: [],
    activeKey: [routesMap.MEDICINE],
  },
  {
    path: routesMap.EDIT_TREATMENT,
    component: EditTreatmentPage,
    rule: -1,
    openKey: [],
    activeKey: [routesMap.CUSTOMER],
  },
  {
    path: routesMap.PROCESS,
    component: ProcessPage,
    rule: -1,
    openKey: [],
    activeKey: [routesMap.PROCESS],
  },
  {
    path: routesMap.PROCESS_TREATMENT,
    component: ProcessTreatment,
    rule: -1,
    openKey: [],
    activeKey: [routesMap.PROCESS],
  },
  {
    path: routesMap.ACTIVITY_LOG,
    component: ActivityLogPage,
    rule: -1,
    openKey: [],
    activeKey: [routesMap.ACTIVITY_LOG],
  },
  {
    path: routesMap.SEARCH,
    component: SearchPage,
    rule: -1,
    openKey: [],
    activeKey: [routesMap.SEARCH],
  },
  {
    path: routesMap.RECALL,
    component: RecallPage,
    rule: -1,
    openKey: [],
    activeKey: [routesMap.RECALL],
  },
  {
    path: routesMap.DEBT,
    component: DebtPage,
    rule: -1,
    openKey: [],
    activeKey: [routesMap.DEBT],
  },
];

export function useRoutes() {
  return useMemo(() => routes, []);
}